import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Per ĉiu parto de sia korpo ri strebis antaŭen. Nenio povis haltigi rin: ri ĉiirkaŭiris, ĉiirkaŭfluis ĉiiujn obstaklojn en nehaltigebla impeto. 
      Ri mem estis impeto! 
      Okupinte iun terenon, ri plene surfluis sur ĝin, fariĝinte mem tiu tereno. 
      Tiam antaŭe restis nur tio, kio denove fariĝos ri mem, kiam ri atingos ĝin. En senĉesa moviĝo, la spaco kaj tempo kunfluiĝis en tiu torento da viva forto.
    </p>
    
    <p class="mb-3">
      Amebo daŭrigis sian moviĝon en guto da akvo.
    </p>
    `
  )
}

const itemName = {
  esp: 'Moviĝo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;